<template>
    <div class="loading">
        <myHeader :headerData="headerData"></myHeader>
    </div>
</template>

<script>
    import myHeader from '../components/header.vue';
    export default {
        name: 'loading',
        components: {
            myHeader
        },
        created () {
        },
        mounted() {
            this.username = this.$route.query.username || this.$route.query.userName;
            this.password = this.$route.query.password;
            this.type = this.$route.query.type;
            this.platform=this.$route.query.platform;  
            console.log(this.platform)         
            sessionStorage.setItem('addressId', this.$route.query.addressId);
            // this.login();
            let params = {} ;
            if(this.type==1){
                params={name: 'chooseAddress',query:{platform:this.platform}}

            }else{
                params={name: 'addressManage'}
            }
            this.$router.push(params)            
        },
        methods: {
            login(){
                let params = {
                    client_id: "sites.myprofile",
                    client_secret: "smartx",
                    grant_type: "password",
                    username: this.username,
                    password: this.password
                }
                var _this = this;
                this.$http.login(this.$api.login, params, function (res) {
                    sessionStorage.setItem('token', res.access_token);
                    sessionStorage.setItem('token_type', res.token_type);
                    var typeRouter='';
                    var params={};
                    if(_this.type==1){
                        params={name: 'chooseAddress',query:{platform:_this.platform}}

                    }else{
                        params={name: 'addressManage'}
                    }
                    _this.$router.push(params)
                })
            }
        },
        data () {
            return {
                headerData: {
                    name: '载入中',
                    isOut: true,
                    save: false,
                    manage: false
                },
                username: '',
                password: '',
                platform:''
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/loading.vue